import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { exportDashboardPDF } from "@/lib/exportDashboardPdf";
import { buildReportParams } from "./dashboardFilters";

const MIME = { csv: "text/csv", xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", pdf: "application/pdf" };

function downloadBlob(data, mime, filename) {
  const a = document.createElement("a");
  a.href = URL.createObjectURL(new Blob([data], { type: mime }));
  a.download = filename;
  document.body.appendChild(a); a.click(); a.remove();
  URL.revokeObjectURL(a.href);
}

// Exportações do Dashboard: relatório de dados (CSV/XLSX/PDF, com filtros ativos) e snapshot visual do painel.
export function useDashboardExport({ filters, dashboardRef, empresaNome }) {
  const [exportingPdf, setExportingPdf] = useState(false);
  const [exportingRep, setExportingRep] = useState(null); // 'csv' | 'xlsx' | 'pdf' | null

  const exportPainelPdf = async () => {
    if (!dashboardRef.current) return;
    setExportingPdf(true);
    try {
      const periodo = filters.start || filters.end ? `${filters.start || "início"} → ${filters.end || "hoje"}` : "sem filtro de data";
      const r = await exportDashboardPDF(dashboardRef.current, { empresaNome: empresaNome || "", periodo });
      toast.success(`PDF gerado · ${r.pages} página(s) · pronto pra reunião`);
    } catch (e) {
      console.error("Falha ao exportar Dashboard PDF", e);
      toast.error(e?.message || "Erro ao gerar PDF do Dashboard");
    } finally { setExportingPdf(false); }
  };

  const exportReport = async (kind) => {
    setExportingRep(kind);
    try {
      const r = await api.get(`/reports/${kind}?${buildReportParams(filters).toString()}`, { responseType: "blob" });
      downloadBlob(r.data, MIME[kind], `entregas-${new Date().toISOString().slice(0, 10)}.${kind}`);
      toast.success(`${kind.toUpperCase()} baixado com os filtros ativos`);
    } catch (e) {
      console.error(`Falha ao exportar ${kind}`, e);
      toast.error(e?.response?.data?.detail || `Erro ao gerar ${kind.toUpperCase()}`);
    } finally { setExportingRep(null); }
  };

  const baixarRelatorioApresentacao = async () => {
    try {
      const r = await api.get(`/apresentacao/report.pdf`, { responseType: "blob" });
      downloadBlob(r.data, MIME.pdf, `apresentacao-${new Date().toISOString().slice(0, 16).replace(/[:T]/g, "")}.pdf`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erro ao gerar PDF");
    }
  };

  return { exportingPdf, exportingRep, exportPainelPdf, exportReport, baixarRelatorioApresentacao };
}
